import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { User } from '../_models/index';
import { AlertService, AuthenticationService, UserService } from '../_services/index'
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { environment } from '../../environments/environment';
import { PaymentServices } from '../_services/payment.services';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidateEmail } from '../_helpers/custom-validators';
import { TranslateService } from '@ngx-translate/core';
declare let Ladda: any

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})
export class NavComponent {
  currentUser: any;
  res_details: any;
  emailForm: FormGroup
  profile_pic: any
  res_name: any
  backendUrl: any;
  branchCount: any;
  branch_type: any;
  appid: any;
  view_error: any;
  error: any;
  nav_menu: any = [];
  lang: any
  web_url;
  new_url: any = [];
  role_val: any;
  rt_id: any;
  showModel: boolean = false;
  submitted: boolean = false;
  showError: any = '';
  lang_value: any;
  phoneMaxLength: any = 10;
  titleMessage: any = ''
  dataLoad: boolean = false;
  menuItems: any = {};
  loadMenuStatus: boolean = true;
  commingStatus: boolean = false;
  name: any = "Foodbot";
  partnerId: any = '';
  itemsDataLoad: boolean = true;

  constructor(private userService: UserService, private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService, private http: Http,
    private paymentService: PaymentServices,
    private translate: TranslateService,
    private location: Location
  ) {

    this.userService.componentMethodCalled$.subscribe((data) => {
      localStorage.removeItem('menu_items');
      this.lang = data.lang;
      this.ngOnInit();
      if (data.status) {
        this.loadMenuStatus = true;
        this.commingStatus = true;
      }
    });



  }

  ngOnInit() {
    if (!this.commingStatus)
      this.router.events.subscribe(val => {
        if (this.location.path() == '' || this.location.path() == '/login' || this.location.path() == '/diagnosis') {
          this.loadMenuStatus = false;
        }
      });

    // this.backendUrl = environment.url;
    this.backendUrl = window.location.origin
    this.backendUrl += "/apis"
    if (this.backendUrl == 'https://stage-backend.foodbot.ai') {
      this.web_url = 'https://stage-web.foodbot.ai/fa.html'
    } else if (this.backendUrl == 'https://uat-backend.foodbot.ai') {
      this.web_url = 'https://uat-web.foodbot.ai/fa.html'
    } else {
      this.web_url = 'https://factura.foodbot.ai/fa.html'
    }
    let whitelabelSetting = JSON.parse(localStorage.getItem('whiteLabelSetting'))
    if (whitelabelSetting && whitelabelSetting.dashboard) {
      this.partnerId = whitelabelSetting.partner_id;
      this.name = whitelabelSetting.partner_name
    }
    this.translate.get(['nav_mobile_exist', 'nav_email_exist', 'nav_emaili_mobile_exist', 'nav_header_message_email_mobile', 'nav_header_message_email', 'nav_header_message_mobile', 'nav_title_message']).subscribe(res => {
      this.lang_value = res;
      this.appid = environment.appid;

      this.currentUser = JSON.parse(localStorage.getItem('currentUser'));

      let currentUser = JSON.parse(localStorage.getItem('currentUser'));
      if (currentUser) {
        let u_locale = currentUser.user_locale ? currentUser.user_locale : 'en_US';
        if (u_locale.indexOf("_") != -1) {
          let arr = u_locale.split('_');
          u_locale = arr[0];
        }
        else {
          u_locale = 'en';
        }
        this.lang = u_locale;

        this.translate.setDefaultLang(u_locale);


        $(document).ready(function () {

          $('.openDropdown').click(function () {
            if (currentUser.role_id != 13) {
              setTimeout(() => {
                $('.profile-element').addClass('open');
                $('.dropdown-toggle').attr('aria-expanded', true);
              }, 0);

            }
          });
        });
        //this.loadAllUsers();
        // let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let user_id = currentUser.user_id;
        let restaurant_id = currentUser.restaurant_id;
        // console.log("restaurant_id----------",restaurant_id);
        let role_id = currentUser.role_id;
        this.role_val = currentUser.role_id

        this.menuItems = (JSON.parse(localStorage.getItem('menu_items'))) ? JSON.parse(localStorage.getItem('menu_items')) : {}


        if (!this.menuItems || !this.menuItems.profileData || this.menuItems.profileData == '') {
          this.userService.getUserProfileData(this.backendUrl, JSON.stringify({ 'user_id': user_id }))
            .subscribe(data => {
              //console.log(data);
              if (data.length) {
                if ((data.err != undefined) && data.err.length > 0) {
                  this.view_error = data;
                  this.error = data.err;
                  $('#fail').show();
                } else {
                  let name = data.filter(x => x.restaurant_id == restaurant_id);
                  this.res_details = data;
                  if (data[0].profile_pic) {
                    this.profile_pic = data[0].profile_pic;
                  }
                  else {
                    this.profile_pic = 'https://res.cloudinary.com/dn2mchqlr/image/upload/v1667912285/download.png';
                  }
                  this.menuItems.profileData = data;
                  localStorage.setItem('menu_items', JSON.stringify(this.menuItems))

                  if (name.length > 0) {
                    this.res_name = name[0].restaurant_name;
                  }
                }
              }
            },
              error => {
                this.alertService.error(JSON.stringify(error));
              })
        }
        else {
          var data = this.menuItems.profileData;
          let name = data.filter(x => x.restaurant_id == restaurant_id);
          this.res_details = data;
          if (data[0].profile_pic) {
            this.profile_pic = data[0].profile_pic;
          }
          else {
            this.profile_pic = 'https://res.cloudinary.com/dn2mchqlr/image/upload/v1667912285/download.png';
          }

          this.menuItems.profileData = data;
          localStorage.setItem('menu_items', JSON.stringify(this.menuItems))

          if (name.length > 0) {
            this.res_name = name[0].restaurant_name;
          }
        }
        if (restaurant_id != undefined) {
          // this.userService.countRestaurentId(this.backendUrl, JSON.stringify({ 'restaurant_id': restaurant_id }))
          //   .subscribe(data1 => {
          //     if ((data1.err != undefined) && data1.err.length > 0) {
          //       this.view_error = data1;
          //       this.error = data1.err;
          //       $('#fail').show();
          //     } else {
          //       this.branchCount = data1[0].namesCount;
          //     }
          //   },
          //     error => {
          //       this.alertService.error(JSON.stringify(error));
          //     });
        }

        // this.userService.GetRouteIdByRouteName(this.backendUrl, JSON.stringify({ 'sub_route': this.router.url }))
        //   .subscribe(data => {
        //     if (data.length > 0) {
        //       this.rt_id = data[0].route_id
        //     }
        //   })

        // console.log("lang----------",this.lang,currentUser.user_locale);
        if (!this.menuItems || !this.menuItems.menu_item || this.menuItems.menu_item == '') {
          this.userService.getNavMenuByRoleId(this.backendUrl, JSON.stringify({ 'role_id': role_id, "lang": this.lang }))
            .subscribe(data => {
              // console.log(data);

              if ((data.err != undefined) && data.err.length > 0) {
                this.view_error = data;
                this.error = data.err;
                $('#fail').show();
              } else {
                var arr = [];
                Object.keys(data).forEach(function (key) {
                  arr[key] = data[key];
                });
                for (var i = 0; i < arr.length; i++) {
                  // console.log(arr);
                  let arr1 = [];
                  let arr2 = [];
                  Object.keys(arr[i]['sub_menu']).forEach(function (key) {
                    Object.keys(arr[i]['sub_menu'][key]).forEach(function (keys) {
                      if (keys == 'sub_sub') {
                        let arr3 = [];
                        Object.keys(arr[i]['sub_menu'][key][keys]).forEach(function (keyss) {
                          arr3[keyss] = arr[i]['sub_menu'][key][keys][keyss];
                        });
                        arr[i]['sub_menu'][key][keys] = arr3;
                      }
                      arr2[keys] = arr[i]['sub_menu'][key][keys];
                    });
                    arr1[key] = arr[i]['sub_menu'][key];
                  });

                  arr[i]['sub_menu'] = arr1;
                  this.new_url = arr2['route_label'];
                }
                // console.log(arr);  
                this.nav_menu = [...arr];
                this.menuItems.menu_item = this.nav_menu
                localStorage.setItem('menu_items', JSON.stringify(this.menuItems))
                this.createDropDown()
              }
            },
              error => {
                if (error.status == 401) {
                  this.http.get(this.backendUrl + '/generate_token', JSON.stringify({}))
                    .map(res => res.json())
                    .subscribe(response => {
                      (localStorage.getItem('id_token') != undefined) ? localStorage.setItem('id_token', response.token) : localStorage.setItem('login_token', response.token);

                      this.ngOnInit();
                    }
                    );
                } else {

                  this.alertService.error(JSON.stringify(error));
                }
              })
        }
        else {
          this.nav_menu = this.menuItems.menu_item;
          this.createDropDown()
        }

        this.createForm();
      }
    })
  }

  showDropDown() {

  }

  createDropDown() {
    var self = this;

    $(document).ready(function () {



      $('.nav-second-level li a').click(function (event) {
        event.stopImmediatePropagation();
        if ($(this).parent('li').hasClass('active')) {
          $(this).parent('li').removeClass('active')
          $(this).next('ul').removeClass('in').slideUp()
        }
        else {
          $(this).parent('li').addClass('active')
          $(this).next('ul').addClass('in').slideDown()
        }
      });

      $('.nav>li>a').click(function (event) {
        event.stopImmediatePropagation();
        if ($(this).parent('li').hasClass('active')) {
          $(this).parent('li').removeClass('active')
          $(this).next('ul').removeClass('in').slideUp()
        }
        else {
          $('.nav>li').removeClass('active')
          $('ul.nav-second-level').hide()
          $(this).parent('li').addClass('active')
          $(this).next('ul').addClass('in').slideDown()
        }

      });

      $('#main_5').removeClass('active');
      $('#side-menu').metisMenu();
      let url = self.router.url;
      let curr_urls = url.split(';')[0]
      let curr_url_arr = curr_urls.split('/');
      let curr_url = '/' + curr_url_arr[1];
      console.log(curr_url)
      let arr = self.nav_menu.filter(function (element) {
        return element.sub_menu.some(function (subelement) {
          return subelement.route == curr_url || curr_url == '/payment'
        })
      })
      let arr1 = self.nav_menu.filter(function (element) {
        return element.sub_menu.some(function (subelement) {
          return subelement.route_id == self.rt_id
        })
      })
      if (arr.length > 0) {
        $('#main_' + arr[0].menu_id).addClass('active');
        $('#ul_' + arr[0].menu_id).addClass('in');
      } else {
        if (arr1.length > 0) {

          console.log('22222222222222', arr1[0].menu_id)

          $('#main_' + arr1[0].menu_id).addClass('active');
          $('#ul_' + arr1[0].menu_id).addClass('in');
          $('#li_' + self.rt_id).addClass('active')
          $('.sub_type_' + self.rt_id).addClass('in')
        }
      }
      $('.nav-second-level li a').click(function (event) {
        $('.nav-second-level li a').removeClass('active');
        $(this).addClass('active')
      })
    });
  }

  changerest(branch_id, restaurant_id, role_id, single_branch, same_menu, country) {
    this.itemsDataLoad = false;
    //  return;
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let dat = this.res_details.filter(x => x.restaurant_id === restaurant_id);
    let user_id = currentUser.user_id;
    let first_name = currentUser.first_name;
    let last_name = currentUser.last_name;
    let email = currentUser.email;
    let phone_number = (currentUser.phone_number != undefined) ? currentUser.phone_number : '';
    let bot_language = dat[0].bot_language;
    let time_zone = dat[0].time_zone;
    this.userService.getCampaignIdByRoleId(this.backendUrl, JSON.stringify({ 'role_id': role_id, 'restaurant_id': restaurant_id }))
      .subscribe(data => {
        var rou = window.location.href;
        var url = rou.split('/');
        let campaign_id = data.campaign_id;
        let user_management_roleId = data.user_management_roleId;
        let quick_reply_id = data.quick_reply_id;
        let udata = { 'first_name': first_name, 'email': email, 'last_name': last_name, 'phone_number': phone_number, 'user_id': user_id, 'restaurant_id': restaurant_id, 'branch_id': branch_id, 'role_id': role_id, 'same_menu': same_menu, 'single_branch': single_branch, 'bot_language': bot_language, 'campaign_id': campaign_id, 'user_management_roleId': user_management_roleId, 'quick_reply_id': quick_reply_id, "user_locale": currentUser.user_locale, "time_zone": time_zone, 'utc_timezone': dat[0].timezone, 'country': country, 'status': currentUser.status };
        localStorage.setItem('currentUser', JSON.stringify(udata));
        localStorage.removeItem('menu_items');
        this.ngOnInit();

        this.paymentService.checkPlanActivationStatus({ 'user_id': user_id, 'restaurant_id': restaurant_id }).subscribe((response: any) => {
          if (response.data.length == 0) {
            // this.router.navigated = true;
            if (this.partnerId == 'd9e20344-0afc-4aa9-adce-615f4ebc6181') {
              this.router.navigateByUrl('/payment', { skipLocationChange: true }).then(() => {
                this.router.navigate(['/payment/plans']);
              });
            } else {
              this.router.navigate(['/profiles']);
            }
            // this.router.navigate(['/payment/plans'])
          }
          else {
            this.itemsDataLoad = true;
            // this.router.navigate(['/profiles']);
            let currtime = moment().format("YYYY-MM-DD HH:mm:ss")
            this.router.navigate(['profiles', { refresh: currtime }]);
          }

        })

        //this.router.navigate(['/profiles']);
        // if(url[3] == 'profiles') {
        //   this.router.navigate(['/']);
        // }else {
        //   this.router.navigate(['/profiles']);
        // }
      })
  }

  navigateToResource(): void {
    window.open(this.web_url);
  }


  createForm() {

    this.emailForm = new FormGroup({
      email_id: new FormControl('', []), // , 
      mobile_number: new FormControl('', []),
    });

    this.dataLoad = true

    if (this.currentUser.status && (this.currentUser.status.email == '' || !this.currentUser.status.mobile || this.currentUser.status.mobile == '')) {

      this.showModel = true;
      if (this.currentUser.status.email == '') {
        $(document).ready(function () {
          $("#emails").focus()
        })
        this.emailForm.controls.email_id.setValidators([Validators.required, Validators.email, ValidateEmail]);
        this.emailForm.controls.email_id.updateValueAndValidity();
        this.titleMessage = this.lang_value.nav_header_message_email
      }

      if (!this.currentUser.status.mobile || this.currentUser.status.mobile == '') {

        // console.log('come inside')

        $(document).ready(function () {
          $("#mobiles").focus()
        })
        this.titleMessage = this.lang_value.nav_header_message_mobile
        if (this.currentUser.country && this.currentUser.country.toLowerCase() == 'paraguay') {
          // console.log('come inside11')
          this.phoneMaxLength = 9
          this.emailForm.controls.mobile_number.setValidators([Validators.required, Validators.minLength(9), Validators.maxLength(13), Validators.pattern("^((?!(0))[0-9]{9})$")]);
        }
        else {
          // console.log('come inside22')
          this.phoneMaxLength = 10
          // , Validators.pattern("^((?!(0))[0-9]{13})$")
          this.emailForm.controls.mobile_number.setValidators([Validators.required, Validators.minLength(9), Validators.maxLength(13)]);
        }
        this.emailForm.controls.mobile_number.updateValueAndValidity();
      }

      if (this.currentUser.status.email == '' && this.currentUser.status.mobile == '') {
        this.titleMessage = this.lang_value.nav_header_message_email_mobile;
        $(document).ready(function () {
          $("#emails").focus()
        })
      }
    }


  }

  get f() { return this.emailForm.controls; }

  saveForm() {
    this.submitted = true;
    this.showError = '';
    if (this.emailForm.valid) {
      this.submitted = false;
      var l = Ladda.create(document.querySelector('#nextBtn'));
      l.start();
      this.emailForm.value.user_id = this.currentUser.user_id
      this.userService.updateRestaurantUserEmail(this.emailForm.value).subscribe((response: any) => {
        l.stop();
        if (response.message == "success") {

          if (this.emailForm.value.email_id != '')
            this.currentUser.status.email = this.emailForm.value.email_id
          if (this.emailForm.value.mobile_number != '')
            this.currentUser.status.mobile = this.emailForm.value.mobile_number

          localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
          this.showModel = false;

        }
        else {
          if (response.type == 'email') {
            this.showError = this.lang_value.nav_email_exist;
          }

          if (response.type == 'mobile') {
            this.showError = this.lang_value.nav_mobile_exist;
          }

          if (response.type == 'both') {
            this.showError = this.lang_value.nav_emaili_mobile_exist;
          }

        }
      })

    }

  }

  goToRouterLink(router: any) {
    let split = router.split(";")
    if (split[1]) {
      let split1 = split[1].split("=")
      console.log('dddddddddd11111111111', split1)
      if (split1[1]) {
        this.router.navigate([`${split[0]}`, { [split1[0]]: split1[1] }]);
      }
      else {
        this.router.navigate([`${split[0]}`]);
      }
    }
    else {
      this.router.navigate([`${router}`]);
    }


  }

  cancel_popup(){
    this.showModel = false;
  }
}




// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/global/navigation.component.ts